import { getCurrentInstance, onMounted, ref } from 'vue'
import { createGlobalState, useEventListener } from '@vueuse/core'
import { useResponsiveOverride } from '@/helpers/vueHelpers.js'
import { compareWithinSigma } from '@/utils/numberUtils.js'

export const useGlobalState = createGlobalState(() => {
  const windowHeight = ref(window.innerHeight)
  const showSiteHeader = ref(true)
  const showSiteFooter = ref(true)
  const siteHeaderMode = ref('dynamic')
  const siteHeaderHeight = ref(0)
  const siteHeaderBottom = ref(0)
  const mountedComponents = []
  const virtualKeyboardHeight = ref(0)

  // scroll is requried to handle iOS safari scroll to hide address bar hehavior
  let prevWindowInnerHeight
  const setWindowHeight = () => {
    windowHeight.value = window.visualViewport?.height || window.innerHeight
    virtualKeyboardHeight.value = window.innerHeight - (window.visualViewport?.height || window.innerHeight)

    // virtual keyboard detection:
    const offset = window.visualViewport?.offsetTop
    const innerHeightDiff = window.innerHeight - prevWindowInnerHeight
    const keyboardLikelyOpen = virtualKeyboardHeight.value > 0
    const keyboardJustClosed = keyboardLikelyOpen && offset && compareWithinSigma(innerHeightDiff, offset, 1)
    document.body.classList.toggle('virtual-keyboard-open', keyboardLikelyOpen && !keyboardJustClosed)

    prevWindowInnerHeight = window.innerHeight
  }
  useEventListener(window, ['resize', 'scroll'], setWindowHeight)
  useEventListener(window.visualViewport, ['resize', 'scroll'], setWindowHeight)

  function onFirstMounted(callback) {
    const instance = getCurrentInstance()
    const component = instance.type.name || instance.type.__name
    if (!mountedComponents.includes(component)) {
      onMounted(callback)
      mountedComponents.push(component)
    }
  }

  function hideSiteFooter(options = { desktop: true, mobile: true }) {
    useResponsiveOverride(showSiteFooter, false, options)
  }

  function makeSiteHeaderStatic(options = { desktop: true, mobile: true }) {
    useResponsiveOverride(siteHeaderMode, 'static', options)
  }

  return {
    windowHeight,
    showSiteHeader,
    showSiteFooter,
    siteHeaderMode,
    siteHeaderHeight,
    siteHeaderBottom,
    makeSiteHeaderStatic,
    hideSiteFooter,
    onFirstMounted,
    virtualKeyboardHeight,
  }
})
